import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getData } from '../redux/actions/restaurant';

function About({ getData, aboutus }) {
    const [close, SetClose] = useState(false);

    useEffect(() => {
        getData();

    }, [])


    const closeMe = () => {
        SetClose(true);
    }

    if (close) {
        return <Redirect to="/" />
    }


    return (
        <>
            <header className="fixed header-blue">
                <div className="container">
                    <div className="header-top">
                        <div className="header-top-left">
                            <span className="back"><img className="img-dark" src="/images/arrow-back.png" alt="" />
                                <img className="img-white" src="/images/arrow-back-white.png" alt="" onClick={closeMe} />
                            </span>
                        </div>
                        <div className="header-top-mid">
                            <span className="font-semibold">About Us </span>
                        </div>
                        <div className="header-top-right"></div>
                    </div>
                </div>
            </header>
            <div className="view-cart" style={{ marginTop: "51px" }}><div className="container">
                {aboutus}
            </div></div>
        </>
    )
}

const mapStateToProps = (state) => ({
    aboutus: state.restaurant?.details?.about_us
})

export default connect(mapStateToProps, { getData })(About)
